
const CheckedIcon = (props: any = {}) => {
    return (
        <svg width="16" height="16" {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M10.891 1.83057H5.11163C3.09763 1.83057 1.83496 3.25657 1.83496 5.27457V10.7199C1.83496 12.7379 3.09163 14.1639 5.11163 14.1639H10.8903C12.911 14.1639 14.1683 12.7379 14.1683 10.7199V5.27457C14.1683 3.25657 12.911 1.83057 10.891 1.83057Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.62891 7.99606L7.21157 9.57806L10.3756 6.41406" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default CheckedIcon